//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import card from '@/components/card/card.vue';
import pluginCard from '@/components/card/plugin-card.vue';
import empty from '@/components/empty.vue';
import { pluginApiUrlMap } from '@/api/url';
import {
  searchResourceByLabel,
  searchPluginByLabel,
  searchResourceByKeyword,
  searchPluginByKeyword,
  page_size,
} from '@/api/search';
import { resourseOpts, pluginOpts } from '@/utils/enum';

let ticking = false;
let isClick = false;

export default {
  components: {
    card,
    pluginCard,
    empty,
  },
  props: {
    is_tag_search: {
      type: Boolean,
      default: true,
    },
    search_key: {
      type: String,
      default: '',
    },
    tag_name: {
      type: String,
      default: '',
    },
    cata_name: {
      type: String,
      default: '资源',
    },
    defaultChoosed: {
      type: [Number, String],
      default: 0,
    },
    initServerData: {
      type: Object,
      default() {
        return {
          resourseList: [],
          pluginList: [],
        };
      },
    },
  },
  data() {
    return {
      loading: false,
      isEmpty: false,
      pluginLoading: false,
      isPluginEmpty: false,
      page_num: 1,
      total: 0,
      plugin_page_num: 1,
      plugin_total: 0,
      searchVal: '',
      resourceList: [],
      pluginList: [],
      filterTop: 0,
      isDataNoMore: false,
      isPluginNoMore: false,
    };
  },
  computed: {
    isResourceActive() {
      return this.cata_name === '资源';
    },
    isPluginActive() {
      return this.cata_name === '插件';
    },
    noMore() {
      return this.isResourceActive ? this.isDataNoMore : this.isPluginNoMore;
    },
    emptyText() {
      const typeText = this.isResourceActive ? '资源': '插件';

      return this.is_tag_search ? `该标签下暂无任何${ typeText }` : `抱歉，我们没有找到任何与该搜索相关的${ typeText }`;
    },
    searchIsEmpty() {
      return (this.isResourceActive && this.isEmpty) || (this.isPluginActive && this.isPluginEmpty);
    },
    showList() {
      return this.isResourceActive ? this.resourceList : this.pluginList;
    },
    action_position() {
      return this.search_key ? 'search' : 'community';
    },
  },
  watch: {
    search_key() {
      this.initData();
    },
    defaultChoosed() {
      this.initData(true);
    },
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollEvent);
  },
  created() {
    this.initServeData();
  },
  mounted() {
    this.$nextTick(this.getFilterTop);
    this.loadMoreData();
  },
  methods: {
    getFilterTop() {
      let top = this.$refs.content?.offsetTop;
      const topbar = this.$store.state.app.topbar;
      const filterHeight = document.querySelector('#filter_tool')?.offsetHeight || 0;
      top = top - topbar - filterHeight;
      if (this.isMobileSize()) {
        const inputHeight = document.querySelector('#filter-search')?.offsetHeight || 0;
        top -= inputHeight;
      }
      this.filterTop = top;
    },
    isMobileSize() {
      const clientWidth = document.body.clientWidth;
      return clientWidth <= 740;
    },
    initServeData() {
      const {
        initServerData: { resourceList, pluginList, total, plugin_total },
      } = this;
      this.resourceList = resourceList;
      this.pluginList = pluginList;
      this.total = total;
      this.plugin_total = plugin_total;
      this.isEmpty = !resourceList.length;
      this.isPluginEmpty = !pluginList.length;
      if (process.client) {
        if (this.isEmpty || this.$store.state.user.userInfo.id) this.initResourceData();
        if (this.isPluginEmpty || this.$store.state.user.userInfo.id) this.initPluginData();
        this.isDataNoMore = resourceList.length && resourceList.length < page_size;
        this.isPluginNoMore = pluginList.length && pluginList.length < page_size;
      }
    },
    async initResourceData() {
      this.loading = true;
      const { tag_name, search_key, page_num, defaultChoosed } = this;
      let res = null;
      try {
        if (this.isEmpty) {
          res = await searchResourceByKeyword('', page_num, resourseOpts.find(item => item.label === '综合排序')?.value || 0);
        } else if (this.is_tag_search) {
          res = await searchResourceByLabel(tag_name, page_num, defaultChoosed || 0);
        } else {
          res = await searchResourceByKeyword(search_key, page_num, defaultChoosed || 0);
        }
        const { code, data = [], meta } = res;
        if (code === 'OK') {
          this.loading = false;
          if (!this.isEmpty) {
            this.total = meta.total || meta.page?.total;
          }
          if (this.resourceList.length && this.page_num !== 1) {
            if (data?.length) this.resourceList = this.resourceList.concat(data);
          } else {
            if ((!data || !data.length) && !this.isEmpty) {
              this.isEmpty = true;
              this.initResourceData();
              return;
            }
            this.resourceList = data || [];
          }
          if (data?.length !== page_size) {
            this.isDataNoMore = true;
          }
          this.$emit('updateTotal', this.total, this.plugin_total);
        }
      } catch (error) {
        console.warn(error);
      }
    },
    async initPluginData() {
      this.pluginLoading = true;
      const { tag_name, search_key, plugin_page_num, defaultChoosed } = this;
      let res = null;
      try {
        if (this.isPluginEmpty) {
          res = await searchPluginByKeyword('', plugin_page_num, pluginOpts.find(item => item.label === '综合排序')?.value || 0);
        } else if (this.is_tag_search) {
          res = await searchPluginByLabel(tag_name, plugin_page_num, defaultChoosed || 0);
        } else  {
          res = await searchPluginByKeyword(search_key, plugin_page_num, defaultChoosed || 0);
        }
        const { code, data = [], meta } = res;
        if (code === 'OK') {
          this.pluginLoading = false;
          if (!this.isPluginEmpty) {
            this.plugin_total = meta.page.total;
          }
          if (this.pluginList.length && this.plugin_page_num !== 1) {
            if (data?.length) this.pluginList = this.pluginList.concat(data);
          } else {
            if ((!data || !data.length) && !this.isPluginEmpty) {
              this.isPluginEmpty = true;
              this.initPluginData();
              return;
            }
            this.pluginList = data || [];
          }
          if (data?.length !== page_size) {
            this.isPluginNoMore = true;
          }
          this.$emit('updateTotal', this.total, this.plugin_total);
        }
      } catch (error) {
        console.warn(error);
      }
    },
    scrollEvent() {
      const that = this;
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
          const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
          const loading = that.isResourceActive ? that.loading : that.PluginLoading;
          const scrollTotal = scrollTop + clientHeight;
          const offsetBottom = 50;
          if (!that.noMore && !loading) {
            if (scrollTotal + offsetBottom >= scrollHeight) {
              that.loadMore();
            }
          }
          ticking = false;
        });
        ticking = true;
      }
    },
    scrollToTop() {
      this.getFilterTop();
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const scroll = scrollHeight - clientHeight;
      if (this.filterTop && scroll >= 0) {
        window.scrollTo({
          top: this.filterTop <= scroll ? this.filterTop : scroll - 10,
        });
      }
    },
    loadMoreData() {
      if (!window) {
        return;
      }
      window.addEventListener('scroll', this.scrollEvent);
    },
    loadMore() {
      if (this.isResourceActive) {
        if (this.noMore || this.loading) return;
        this.page_num++;
        this.initResourceData();
      }
      if (this.isPluginActive) {
        if (this.noMore || this.pluginLoading) return;
        this.plugin_page_num++;
        this.initPluginData();
      }
    },
    init(saveEmpty = false) {
      this.page_num = 1;
      this.plugin_page_num = 1;
      this.resourceList = [];
      this.pluginList = [];
      if (!saveEmpty) {
        this.isEmpty = false;
        this.isPluginEmpty = false;
      }
      this.isDataNoMore = false;
      this.isPluginNoMore = false;
      // this.scrollToTop();
    },
    initData(saveEmpty) {
      this.init(saveEmpty);
      this.initResourceData();
      this.initPluginData();
    },
    download(plugin, index) {
      if (isClick) return;
      isClick = true;
      plugin.loading = true;
      this.$set(this.pluginList, index, plugin);
      const requestUrl = pluginApiUrlMap.pluginInstall;
      this.$axios
        .$post(requestUrl, { plugin_id: plugin.plugin_id })
        .then(() => {
          plugin.is_install = true;
          plugin.loading = false;
          if (plugin.is_install) {
            plugin.install_cnt++;
          }
          this.$set(this.pluginList, index, plugin);
          isClick = false;
        })
        .catch(() => {
          isClick = false;
          plugin.loading = false;
        });
    },
  },
};
